import { Row as AntRow } from 'antd'
import styled from '@emotion/styled'
import { getSpacer } from 'Utils/variables'

export const Row = styled(AntRow)(({ spacer }) => ({
  marginBottom: getSpacer(spacer || 2),
}))
